<template>
    <div>
        <div class="object-titlebox">
                <div class="object-titlebox-left">{{$t('message.item_e2e_encryption_setting')}}</div>
        </div>

        <template v-if="!appData.enableE2EEncryptionOption">
            <div class="object-inner-table">
                <table width=100%>
                    <td width=50% class="object-item">{{$t('message.info_not_available_for_this_tenant')}}</td>
                </table>
            </div>
        </template>

        <template v-else-if="!appData.tenantAdminUser">
            <div class="object-inner-table">
                <table width=100%>
                    <td width=50% class="object-item">{{$t('message.error_cannot_operate_no_tenantAdmin_privilege')}}</td>
                </table>
            </div>
        </template>

        <template v-else>
            <div class="object-inner-table">
                <div class="default-message" style="margin:12px 0px">
                    <span v-html="$t('message.info_e2e_encryption_guide1')"></span>
                    <br>
                    <span v-html="$t('message.info_e2e_encryption_guide2')"></span>
                    <br>
                    <span style="color:#d55169" v-html="$t('message.info_e2e_encryption_guide3')"></span>
                    <br>
                    <span v-html="$t('message.info_e2e_encryption_guide4')"></span>
                    <br>
                    <span style="color:#d55169" v-html="$t('message.info_e2e_encryption_guide5')"></span>
                </div>

                <template v-if="!appData.isRadioIntegrated">
                    <div class="object-titlebox">
                        <div class="object-titlebox-left">
                            <button class="transparent-button" type="button" @click="showEdit=true"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                        </div>
                    </div>
                    <table width=100%>
                        <tr class="objectitem-record">
                            <td width=30% class="object-item">{{$t('message.item_e2e_encryption')}}</td>
                            <td width=30% class="object-value">{{ stateText }}</td>
                            <td v-if="appData.e2eEncryption">
                                <button class='transparent-button' type="button" @click='showPasswordInput=true'><span class="normal-command-text" v-t="'message.item_new_password'"/></button>
                            </td>
                        </tr>
                    </table>
                </template>

                <template v-else>
                    <div class="object-titlebox">
                        <div class="object-titlebox-left">
                            <button class="transparent-button" type="button"><span class="object-command-disabled"><img src="../../../../assets/edit.svg"/><span v-t="'message.common_action_edit'"></span></span></button>
                        </div>
                    </div>
                    <span style="color:#d55169">{{$t('message.error_e2e_encryption_unavailable_with_radio_integration')}}</span>
                </template>

            </div>
            <e2e-encryption-edit v-if="showEdit" :encryption="appData.e2eEncryption" @onSave="setE2EEncryption" @onCancel="showEdit=false"></e2e-encryption-edit>
            <password-input-modal v-if="showPasswordInput" :title="$t('message.item_e2e_encryption_setting')" :label="$t('message.item_new_password')" @onSave="setNewPassword" @onCancel="showPasswordInput=false"></password-input-modal>
        </template>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import E2eEncryptionEdit from '@/components/pc/setting/e2eencryption/E2EEncryptionEdit.vue';
import PasswordInputModal from '../../../PasswordInputModal.vue';

export default {
    components: {
        E2eEncryptionEdit, PasswordInputModal
    },
    props: {
        appData : {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showEdit: false,
            showPasswordInput: false,
        };
    },
    methods: {
        async setE2EEncryption (encryption, pass) {
            this.showEdit = false
            let hashedPass = pass != null ? await commonUtil.sha256(pass) : null

            let res;
            try {
                res = await server.post('/settenante2eencryption', {encryption : encryption, hashedPassword : hashedPass})
            } catch(error){
                commonUtil.putExceptionErrorMessage(this, "setE2EEncryption", error);
                return;
            }

            switch(res.data.status) {
                case constants.STATUS_SUCCESS:
                    commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n,"info_e2e_encryption_changed"));
                    this.appData.e2eEncryption = encryption;
                    break;
                case constants.STATUS_ERROR_DENIED:
                    commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_e2e_encryption_unavailable_with_radio_integration"));
                    break;
                default:
                    commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","setE2EEncryption").replace("{code}",res.data.status));
                    break;
            }
        },
        setNewPassword(pass) {
            this.showPasswordInput = false
            this.setE2EEncryption(true, pass)
        }
    },
    computed: {
        stateText () {
            return this.appData.e2eEncryption ? commonUtil.getMessageText(this.$i18n, "item_value_used") : commonUtil.getMessageText(this.$i18n, "item_value_nonUsed")
        }
    }
}

</script>
<style scoped>
.object-value {
    padding: 10px 10px;
}

.object-title {
    padding: 10px 10px;
    font-size: 12px;
}

.object-command-disabled {
    color: #848991;
    font-size: 12px;
}
.object-command-disabled img {
    opacity: 0.3;
}
</style>
